import React from "react";
import { ManualRequestPagination, SearchFilters_v2 } from '@lp/lp-ui';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { localPaginationSelected, paginationSelected } from "../../app/usersSlice";
import { UserFields, UserListItemModel } from "../../typings";
import { MapManualRequestPaginationToUsersPagination } from "../../mappings";

const UserSearchFilters: React.FC = () => {
    const dispatch = useAppDispatch();

    const { pagination, localPagination } = useAppSelector((s) => s.users);

    const setPagination = (paginationRequest: ManualRequestPagination<UserListItemModel>) => {
        const pgn = MapManualRequestPaginationToUsersPagination(pagination.organizationId, paginationRequest);
        dispatch(paginationSelected({ ...pgn, shouldApplySearch: true }));
    };

    const setLocalPagination = (paginationRequest: ManualRequestPagination<UserListItemModel>) => {
        const pgn = MapManualRequestPaginationToUsersPagination(pagination.organizationId, paginationRequest);
        dispatch(localPaginationSelected(pgn));
    };

    const showSearch =
        JSON.stringify(pagination?.filters ?? {}) !==
            JSON.stringify(localPagination.filters) ||
        pagination?.filterString !== localPagination.filterString;

    return (
        // eslint-disable-next-line react/jsx-pascal-case
        <SearchFilters_v2
            pagination={pagination}
            setPagination={setPagination}
            localPagination={localPagination}
            setLocalPagination={setLocalPagination}
            searchFields={UserFields}
            filterPlaceholder="First/Last Name, Username or Email"
            showSearch={showSearch}
        />
    );
};

export default UserSearchFilters;
